<template>
    <a-drawer :title="$t('mobileConfig.adv_list.title' /* 广告列表 */)" width="900px" id="imageDrawer" placement="right" :closable="true" :visible="visible" @close="visible = false">
        <a-button icon="plus" @click="handleAddAdv">{{ $t('mobileConfig.adv_list.add_adv' /* 新建广告 */) }}</a-button>
        <a-table class="mt15" size="middle" :pagination="false" :custom-row="customRow" :rowKey="record => record.id" :data-source="dataSource" :columns="columns">
            <template slot="drag" slot-scope="text, record">
                <i class="medcon fs24 med-Drag"></i>
            </template>
            <template slot="status" slot-scope="text, record, index">
                <a-switch
                    @change="handleSwitchEvent(index, record)"
                    :loading="record.switchLoading"
                    :checked-children="$t('web.show' /* 显示 */)"
                    :un-checked-children="$t('web.hide' /* 隐藏 */)"
                    :checked="record.status == 1"
                />
            </template>
            <template slot="action" slot-scope="text, record, index">
                <a-button @click="handleEdit(record)" type="primary" size="small">{{ $t('web.edit' /* 编辑 */) }}</a-button>
                <a-button type="danger" class="ml10" size="small" @click="handleDelete(record)">{{ $t('web.delete' /* 删除 */) }}</a-button>
            </template>
        </a-table>

        <adv-edit ref="advEditRef" @refresh="getList"></adv-edit>
        <adv-img-edit ref="advImgEditRef" @refresh="getList"></adv-img-edit>
    </a-drawer>
</template>

<script>
import tableDrag from '@/utils/table.drag.mixins.js';
import AdvEdit from './adv-edit.vue';
import advImgEdit from './adv-img-edit.vue';
import moment from 'moment';
export default {
    name: 'AdvertisingInfo',
    mixins: [tableDrag],
    components: {
        AdvEdit,
        advImgEdit
    },
    data() {
        return {
            columns: [
                {
                    title: this.$t('web.sort' /* 排序 */),
                    scopedSlots: { customRender: 'drag' }
                },
                {
                    title: this.$t('mobileConfig.adv_list.adv_title' /* 标题 */),
                    dataIndex: 'title',
                    align: 'center'
                },
                {
                    title: this.$t('mobileConfig.adv_list.adv_click' /* 点击量 */),
                    dataIndex: 'click',
                    align: 'center'
                },
                {
                    title: this.$t('mobileConfig.adv_list.adv_status' /* 状态 */),
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    align: 'center'
                },
                {
                    title: this.$t('mobileConfig.adv_list.adv_create_time' /* 创建时间 */),
                    dataIndex: 'create_time',
                    align: 'center',
                    customRender: (text, record) => {
                        return moment.unix(text).format('YYYY-MM-DD HH:mm:ss');
                    }
                },
                {
                    title: this.$t('mobileConfig.adv_list.adv_create_user' /* 创建人 */),
                    dataIndex: 'real_name',
                    align: 'center'
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    scopedSlots: { customRender: 'action' },
                    align: 'center'
                }
            ],
            visible: false,
            infoData: {},
            dataSource: [],
            seat: 0 // 0文字广告 1 2 3 图片广告
        };
    },
    methods: {
        showFun(infoData) {
            this.visible = true;
            this.infoData = infoData;
            console.log(infoData);
            if (this.infoData.id) {
                this.getList();
            }
        },
        getList() {
            let data = {
                language: this.$route.params.lang,
                seat_id: this.infoData.id
            };
            this.$request.get({ url: 'getMobileAds', data }).then(res => {
                res.data.data.forEach(v => {
                    v.switchLoading = false;
                });
                this.dataSource = res.data.data;
            });
        },
        onClose() {
            this.$emit('close');
        },
        dragSuccess() {
            console.log('dragSuccess');
            let ids = [];
            this.dataSource.forEach(v => {
                ids.push(v.id);
            });
            let data = {
                language: this.$route.params.lang,
                seat_id: this.infoData.id,
                ids
            };
            this.$request.post({ url: 'setMobileAdSort', data }).then(res => {
                if (res.code == 200) {
                    this.$message.success(this.$t('mobileConfig.adv_list.adv_sort_success' /* 排序成功 */));
                }
            });
        },
        handleSwitchEvent(index, record) {
            record.switchLoading = true;
            let data = {
                language: this.$route.params.lang,
                id: record.id,
                seat_id: this.infoData.id
            };
            this.$request
                .post({ url: 'setMobileSwitch', data })
                .then(res => {
                    if (res.code == 200) {
                        this.$set(this.dataSource[index], 'status', record.status == 1 ? 0 : 1);
                    }
                    record.switchLoading = false;
                })
                .catch(err => {
                    record.switchLoading = false;
                });
        },
        handleEdit(record) {
            if (this.infoData.seat == 0) {
                this.$refs.advEditRef.show(this.infoData.id, record);
            } else {
                this.$refs.advImgEditRef.show(this.infoData.id, record);
            }
        },
        handleAddAdv() {
            if (this.infoData.seat == 0) {
                this.$refs.advEditRef.show(this.infoData.id, {});
            } else {
                this.$refs.advImgEditRef.show(this.infoData.id, {});
            }
        },
        handleDelete(record) {
            this.$confirm({
                title: this.$t('web.tips' /* 提示 */),
                content: this.$t('mobileConfig.adv_list.adv_delete_confirm' /* 确定删除该广告吗？ */),
                okText: this.$t('web.ok' /* 确定 */),
                cancelText: this.$t('web.cancel' /* 取消 */),
                onOk: () => {
                    let data = {
                        language: this.$route.params.lang,
                        id: record.id,
                        seat_id: this.infoData.id
                    };
                    this.$request.post({ url: 'deleteMobileAd', data }).then(res => {
                        if (res.code == 200) {
                            this.$message.success(this.$t('web.delete_success' /* 删除成功 */));
                            this.getList();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped lang="less"></style>
